module.exports = __webpack_public_path__ + "img/estasi_prof.d10574a4.png";